import { useState, useEffect } from "react";

export function useDebounce<P>(
  value: P,
  delay: number,
  options?: { onStart?: (value: P) => void; onEnd?: (value: P) => void },
): P {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    options?.onStart?.(value);
    const handler = setTimeout(() => {
      options?.onEnd?.(value);
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, !!options?.onEnd, !!options?.onStart]);

  return debouncedValue;
}
